<template>
  <div>

    <!-- CONFIRMAR BULK -->
    <transition name="dm-fade">
      <div v-if="showConfirm" class="dm-overlay" @click.self="$emit('update:showConfirm', false)">
        <div class="dm-modal dm-modal-sm">
          <div class="dm-modal-head">
            <div class="dm-modal-icon dm-icon-warn">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>
            </div>
            <div>
              <div class="dm-modal-title">Confirmar alteração</div>
              <div class="dm-modal-sub">Esta ação vai atualizar descontos de vários clientes</div>
            </div>
            <button class="dm-close" @click="$emit('update:showConfirm', false)">✕</button>
          </div>

          <div class="dm-confirm-body">
            <div class="dm-confirm-row">
              <span class="dm-confirm-label">Desconto</span>
              <span class="dm-confirm-val dm-val-orange">{{ bulkDesconto }}%</span>
            </div>
            <div class="dm-confirm-row">
              <span class="dm-confirm-label">Clientes</span>
              <span class="dm-confirm-val"><strong>{{ totalSelected }}</strong> cliente{{ totalSelected !== 1 ? 's' : '' }}</span>
            </div>
            <div class="dm-confirm-row">
              <span class="dm-confirm-label">Restaurantes</span>
              <span class="dm-confirm-val">{{ bulkRestaurantes.length ? bulkRestaurantes.length + ' selecionado(s)' : 'Todos' }}</span>
            </div>
            <div class="dm-confirm-note">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
              O processo corre em segundo plano. Pode fechar esta janela.
            </div>
          </div>

          <div class="dm-modal-foot">
            <button class="dm-btn dm-btn-cancel" @click="$emit('update:showConfirm', false)">Cancelar</button>
            <button class="dm-btn dm-btn-confirm" @click="$emit('do-bulk')">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6 9 17l-5-5"/></svg>
              Confirmar
            </button>
          </div>
        </div>
      </div>
    </transition>

    <!-- PROGRESSO DO BULK -->
    <transition name="dm-fade">
      <div v-if="bulkProgress.visible" class="dm-overlay" @click.self="$emit('close-progress')">
        <div class="dm-modal dm-modal-sm">
          <div class="dm-modal-head">
            <div class="dm-modal-icon" :class="bulkProgress.percent === 100 ? 'dm-icon-ok' : 'dm-icon-run'">
              <svg v-if="bulkProgress.percent === 100" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6 9 17l-5-5"/></svg>
              <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="dm-spin"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
            </div>
            <div>
              <div class="dm-modal-title">
                {{ bulkProgress.percent === 100 ? 'Concluído!' : 'A processar…' }}
              </div>
              <div class="dm-modal-sub">Bulk #{{ bulkProgress.bulkId }}</div>
            </div>
            <button class="dm-close" @click="$emit('close-progress')">{{ bulkProgress.status === 'a_processar' ? 'Minimizar' : '✕' }}</button>
          </div>

          <div class="dm-prog-body">
            <div class="dm-prog-track">
              <div class="dm-prog-fill" :class="bulkProgress.percent === 100 ? 'done' : bulkProgress.erros > 0 ? 'err' : 'run'"
                :style="`width:${bulkProgress.percent}%`"></div>
            </div>
            <span class="dm-prog-pct">{{ bulkProgress.percent }}%</span>
          </div>

          <div class="dm-stats">
            <div class="dm-stat">
              <span class="dm-stat-n">{{ bulkProgress.processados }}<small>/{{ bulkProgress.total }}</small></span>
              <span class="dm-stat-l">processados</span>
            </div>
            <div class="dm-stat dm-stat-ok">
              <span class="dm-stat-n">{{ bulkProgress.sucessos }}</span>
              <span class="dm-stat-l">com sucesso</span>
            </div>
            <div class="dm-stat dm-stat-err">
              <span class="dm-stat-n">{{ bulkProgress.erros }}</span>
              <span class="dm-stat-l">com erro</span>
            </div>
          </div>
          <p class="dm-prog-msg">{{ bulkProgress.message }}</p>
        </div>
      </div>
    </transition>

    <!-- HISTÓRICO -->
    <transition name="dm-fade">
      <div v-if="showHistorico" class="dm-overlay" @click.self="$emit('update:showHistorico', false)">
        <div class="dm-modal dm-modal-lg">
          <div class="dm-modal-head">
            <div class="dm-modal-title">Histórico de atualizações em lote</div>
            <button class="dm-close" @click="$emit('update:showHistorico', false)">✕</button>
          </div>
          <div class="dm-table-scroll">
            <table class="dm-table">
              <thead>
                <tr>
                  <th>#</th><th>Data</th><th>Desconto</th><th>Total</th><th>✔ Sucesso</th><th>✕ Erro</th><th>Estado</th><th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="b in paginatedBulks" :key="b.id">
                  <td><code>{{ b.id }}</code></td>
                  <td>{{ fmtDate(b.criado_em) }}</td>
                  <td><span class="dm-disc-tag">{{ b.desconto }}%</span></td>
                  <td>{{ b.processados }}/{{ b.total }}</td>
                  <td class="dm-ok">{{ b.sucessos }}</td>
                  <td class="dm-err">{{ b.erros }}</td>
                  <td><span class="dm-status-tag" :class="b.status">{{ statusLabel(b.status) }}</span></td>
                  <td>
                    <button v-if="b.erros" class="dm-err-btn" @click="$emit('ver-erros', b.id)">Ver erros</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="dm-hist-pag">
            <button class="dm-pag-btn" :disabled="hPage <= 1" @click="hPage--">‹</button>
            <span class="dm-pag-info">{{ hPage }}/{{ hPages || 1 }}</span>
            <button class="dm-pag-btn" :disabled="hPage >= hPages" @click="hPage++">›</button>
          </div>
        </div>
      </div>
    </transition>

    <!-- ERROS DO BULK -->
    <transition name="dm-fade">
      <div v-if="showErros" class="dm-overlay" @click.self="$emit('update:showErros', false)">
        <div class="dm-modal dm-modal-lg">
          <div class="dm-modal-head">
            <div>
              <div class="dm-modal-title">Erros — Bulk #{{ errosBulkId }}</div>
              <div class="dm-modal-sub">{{ erros.length }} erro{{ erros.length !== 1 ? 's' : '' }}</div>
            </div>
            <button class="dm-close" @click="$emit('update:showErros', false)">✕</button>
          </div>
          <div class="dm-table-scroll">
            <table class="dm-table">
              <thead><tr><th>QR Code</th><th>Restaurante</th><th>Motivo do erro</th></tr></thead>
              <tbody>
                <tr v-for="(e, i) in erros" :key="i">
                  <td><code>{{ e.qr_code }}</code></td>
                  <td>{{ e.restaurante_nome }}</td>
                  <td class="dm-err">{{ e.mensagem }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
const PER = 10;
export default {
  name: "DescontosModais",
  props: {
    showConfirm:      { type: Boolean, default: false },
    bulkDesconto:     { default: null },
    bulkRestaurantes: { type: Array,   default: () => [] },
    totalSelected:    { type: Number,  default: 0 },
    bulkProgress:     { type: Object,  default: () => ({}) },
    showHistorico:    { type: Boolean, default: false },
    bulks:            { type: Array,   default: () => [] },
    showErros:        { type: Boolean, default: false },
    erros:            { type: Array,   default: () => [] },
    errosBulkId:      { default: null },
  },
  data() { return { hPage: 1 }; },
  computed: {
    hPages() { return Math.ceil(this.bulks.length / PER); },
    paginatedBulks() { return this.bulks.slice((this.hPage-1)*PER, this.hPage*PER); },
  },
  watch: { showHistorico(v) { if (v) this.hPage = 1; } },
  methods: {
    fmtDate(d) {
      if (!d) return "—";
      return new Date(d).toLocaleString("pt-PT", { day:"2-digit", month:"2-digit", year:"2-digit", hour:"2-digit", minute:"2-digit" });
    },
    statusLabel(s) {
      return s === "concluído" ? "Concluído" : s === "falhou" ? "Falhou" : s === "a_processar" ? "Em curso" : s || "—";
    },
  },
};
</script>

<style scoped>
.dm-overlay {
  position: fixed; inset: 0;
  background: rgba(15, 10, 8, .5);
  backdrop-filter: blur(6px);
  display: flex; align-items: center; justify-content: center;
  z-index: 1200;
  font-family: 'DM Sans','Outfit',system-ui,sans-serif;
  padding: 16px;
}
.dm-modal {
  background: #fff;
  border-radius: 18px;
  width: 100%;
  max-height: 88vh;
  display: flex; flex-direction: column;
  box-shadow: 0 24px 80px rgba(0,0,0,.22);
  overflow: hidden;
}
.dm-modal-sm { max-width: 420px; }
.dm-modal-lg { max-width: 860px; }

.dm-modal-head {
  display: flex; align-items: center; gap: 14px;
  padding: 20px 24px 16px;
  border-bottom: 1px solid #f5f2ef;
}
.dm-modal-icon {
  width: 44px; height: 44px; border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.dm-icon-warn { background: #fff5f0; color: #ff825d; }
.dm-icon-ok   { background: #e8faf2; color: #0a7a4a; }
.dm-icon-run  { background: #fff8e8; color: #c07800; }
.dm-modal-title { font-size: 15.5px; font-weight: 700; color: #1a1210; }
.dm-modal-sub   { font-size: 12.5px; color: #b0a8a0; margin-top: 2px; }
.dm-close {
  margin-left: auto; background: #f7f4f1; border: none; cursor: pointer;
  width: 30px; height: 30px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; color: #7a736e; flex-shrink: 0;
  transition: all .15s;
}
.dm-close:hover { background: #f0ece8; color: #1a1210; }

/* Confirm */
.dm-confirm-body { padding: 20px 24px; }
.dm-confirm-row { display: flex; justify-content: space-between; align-items: center; padding: 10px 0; border-bottom: 1px solid #f5f2ef; }
.dm-confirm-row:last-of-type { border-bottom: none; }
.dm-confirm-label { font-size: 13.5px; color: #8a857e; }
.dm-confirm-val { font-size: 14px; font-weight: 600; color: #1a1210; }
.dm-val-orange { color: #ff825d; font-size: 20px; font-weight: 800; }
.dm-confirm-note {
  display: flex; align-items: center; gap: 7px;
  margin-top: 16px; padding: 12px 14px;
  background: #f7f4f1; border-radius: 10px;
  font-size: 12.5px; color: #8a857e;
}

.dm-modal-foot {
  display: flex; gap: 8px; justify-content: flex-end;
  padding: 16px 24px;
  border-top: 1px solid #f5f2ef;
}
.dm-btn { padding: 10px 20px; border-radius: 10px; border: none; font-size: 14px; font-weight: 600; cursor: pointer; transition: all .15s; display: flex; align-items: center; gap: 6px; }
.dm-btn-cancel  { background: #f7f4f1; color: #5a534f; }
.dm-btn-cancel:hover { background: #f0ece8; }
.dm-btn-confirm { background: #ff825d; color: #fff; box-shadow: 0 2px 8px rgba(255,130,93,.3); }
.dm-btn-confirm:hover { background: #e86b45; transform: translateY(-1px); }

/* Progress */
.dm-prog-body { display: flex; align-items: center; gap: 12px; padding: 20px 24px 10px; }
.dm-prog-track { flex: 1; height: 8px; background: #f5f2ef; border-radius: 4px; overflow: hidden; }
.dm-prog-fill  { height: 100%; border-radius: 4px; transition: width .4s ease; }
.dm-prog-fill.run  { background: linear-gradient(90deg, #ff825d, #ffb08a); animation: shimmer 1.5s infinite; }
.dm-prog-fill.done { background: #2dce89; }
.dm-prog-fill.err  { background: #f5365c; }
@keyframes shimmer { 0%,100%{filter:brightness(1)}50%{filter:brightness(1.1)} }
.dm-prog-pct { font-size: 14px; font-weight: 700; color: #1a1210; min-width: 38px; text-align: right; }
.dm-stats { display: flex; gap: 8px; padding: 0 24px 14px; }
.dm-stat { flex: 1; text-align: center; background: #faf8f6; border-radius: 10px; padding: 12px 8px; }
.dm-stat-n { display: block; font-size: 22px; font-weight: 800; color: #1a1210; }
.dm-stat-n small { font-size: 13px; font-weight: 400; color: #b0a8a0; }
.dm-stat-l { display: block; font-size: 11px; color: #b0a8a0; margin-top: 2px; }
.dm-stat-ok .dm-stat-n { color: #0a7a4a; }
.dm-stat-err .dm-stat-n { color: #c04820; }
.dm-prog-msg { text-align: center; font-size: 12.5px; color: #b0a8a0; padding: 0 24px 20px; margin: 0; }
@keyframes spin-anim { to { transform: rotate(360deg); } }
.dm-spin { animation: spin-anim .8s linear infinite; }

/* Tables */
.dm-table-scroll { overflow-y: auto; flex: 1; }
.dm-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dm-table th { padding: 10px 16px; background: #faf8f6; font-size: 11px; font-weight: 700; color: #b0a8a0; text-transform: uppercase; letter-spacing: .06em; border-bottom: 1px solid #f0ece8; text-align: left; white-space: nowrap; }
.dm-table td { padding: 11px 16px; border-bottom: 1px solid #f5f2ef; color: #2a2420; }
.dm-table tr:last-child td { border-bottom: none; }
.dm-table tr:hover td { background: #fdfcfb; }
.dm-table code { font-size: 11px; background: #f5f2ef; padding: 2px 6px; border-radius: 4px; color: #5a534f; }
.dm-disc-tag { background: #fff2ee; color: #c04820; font-weight: 700; padding: 2px 8px; border-radius: 5px; font-size: 12.5px; }
.dm-ok  { color: #0a7a4a; font-weight: 700; }
.dm-err { color: #c04820; }
.dm-status-tag { font-size: 12px; font-weight: 600; padding: 3px 9px; border-radius: 20px; background: #f5f2ef; color: #6b6460; }
.dm-status-tag.concluído   { background: #e8faf2; color: #0a7a4a; }
.dm-status-tag.falhou      { background: #fef0ef; color: #c04820; }
.dm-status-tag.a_processar { background: #fff8e8; color: #c07800; }
.dm-err-btn { padding: 3px 10px; background: #fef0ef; border: 1px solid #fac8c0; border-radius: 6px; font-size: 12px; color: #c04820; cursor: pointer; font-weight: 600; }
.dm-err-btn:hover { background: #fad8d0; }

.dm-hist-pag { display: flex; align-items: center; justify-content: center; gap: 12px; padding: 14px; border-top: 1px solid #f5f2ef; }
.dm-pag-btn { width: 30px; height: 30px; border: 1.5px solid #e8e4e0; border-radius: 7px; background: #fff; font-size: 14px; color: #6b6460; cursor: pointer; transition: all .15s; }
.dm-pag-btn:hover:not(:disabled) { border-color: #ff825d; color: #ff825d; }
.dm-pag-btn:disabled { opacity: .35; cursor: default; }
.dm-pag-info { font-size: 13px; color: #b0a8a0; }

.dm-fade-enter-active, .dm-fade-leave-active { transition: opacity .2s; }
.dm-fade-enter, .dm-fade-leave-to { opacity: 0; }
</style>
